export const stepNames = {
  es: {
    personalInformation: "Información personal",
    identification: "Identificación",
    employmentAndFinancialInformation: "Información laboral y financiera",
    investmentExperience: "Conocimiento y experiencia en inversiones",
    accountObjective: "Planificación y uso de la cuenta",
    beneficiaries: "Designación de beneficiarios",
  },
  en: {
    personalInformation: "Personal information",
    identification: "Identification",
    employmentAndFinancialInformation: "Employment and financial information",
    investmentExperience: "Investment knowledge and experience",
    accountObjective: "Planning and use of the account",
    beneficiaries: "Designation of beneficiaries",
  },
};

export const headerTitle = {
  es: "Preconfirmación de datos",
  en: "Data Preconfirmation",
};

export const headerSubtitle = {
  es: "Revisá que los datos sean correctos. Las respuestas aportadas tienen\
    carácter de DDJJ. ",
  en: "Check that the information is correct. The provided responses have\
    the nature of a sworn statement.",
};

export const holder = {
  es: "Titular",
  en: "Holder",
};

export const success = {
  es: {
    title: "¡Terminaste el registro!",
    description:
      "Procesaremos tu solicitud y nos pondremos en contacto a la brevedad.",
  },
  en: {
    title: "You have finished your registration!",
    description: "We will process your request and get in touch shortly.",
  },
};
